export const API_NODE_INIT = 'API_NODE_INIT'
export const API_NODE_SAVE = 'API_NODE_SAVE'
export const API_NODE_UPDATE = 'API_NODE_UPDATE'
export const API_NODE_SELECT_TAB = 'API_NODE_SELECT_TAB'
export const API_NODE_UPDATE_GRAPH_DATA = 'API_NODE_UPDATE_GRAPH_DATA'
